import React from 'react';
import { SELF, BLANK } from '@yme/utils/constants';
import { ImageAtomStyled, ImageLink } from './styled';
export function ImageHolder(props) {
    const { linkURL = '', newTabLink, displayPopupCaption, ...rest } = props;
    const isTargetLink = newTabLink ? BLANK : SELF;
    const imageProps = {
        ...rest,
        displayPopupTitle: displayPopupCaption,
    };
    if (linkURL) {
        return (React.createElement(ImageLink, { href: linkURL, target: isTargetLink },
            React.createElement(ImageAtomStyled, { ...imageProps })));
    }
    return React.createElement(ImageAtomStyled, { ...imageProps });
}
ImageHolder.displayName = 'ImageHolder_Component';
